export default "__VITE_ASSET__BErxxdsU__"